<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { ACCESSIBILITY_STATEMENT } from "@/pages"

const { t } = useI18n({ useScope: "global" })
</script>

<template>
  <RouterLink
    id="accessibilitystatementlink-link-accessibilitystatement"
    :to="{ name: 'DocumentGet', params: { id: ACCESSIBILITY_STATEMENT } }"
    class="link"
    :title="t('footer.accessibilityStatement')"
    >{{ t("footer.accessibilityStatementShort") }}</RouterLink
  >
</template>
